var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94641 5.05314C9.39413 5.05314 8.94641 4.60543 8.94641 4.05314C8.94641 3.50086 9.39413 3.05314 9.94641 3.05314C10.4987 3.05314 10.9464 3.50086 10.9464 4.05314C10.9464 4.60543 10.4987 5.05314 9.94641 5.05314Z",
    fill: "#00B585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55975 0.346477H7.61308L11.6131 0.633144C12.5447 0.716506 13.2831 1.45485 13.3664 2.38648L13.6597 6.38648C13.6966 6.75454 13.5698 7.12019 13.3131 7.38648L7.68641 13.0131C7.44876 13.2421 7.12966 13.3668 6.79975 13.3598C6.29502 13.3554 5.81375 13.146 5.46641 12.7798L1.21975 8.53981C0.560087 7.99293 0.456573 7.0199 0.986414 6.34648L6.64641 0.679811C6.88526 0.452748 7.20356 0.328299 7.53308 0.333144L7.55975 0.346477ZM7.53308 1.41981C7.49402 1.40753 7.45214 1.40753 7.41308 1.41981L1.77975 7.05314C1.72526 7.30301 1.8185 7.56201 2.01975 7.71981L6.27975 11.9798C6.42009 12.1321 6.61321 12.225 6.81975 12.2398H6.93308L12.5464 6.57981C12.5643 6.53257 12.5643 6.48039 12.5464 6.43314L12.2531 2.43314C12.2007 2.07035 11.9209 1.78244 11.5597 1.71981L7.55975 1.43314L7.53308 1.41981Z",
    fill: "#00B585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTag);
export default __webpack_public_path__ + "static/media/green-tag.031fd8bebc0699b9ed1540efe5a7770b.svg";
export { ForwardRef as ReactComponent };